import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ReportService } from "../../../services/ReportService";
import PrintButton from "../../../components/buttons/PrintButton";
import { DateTime } from "luxon";

export default function ReportFechamentoDepPessoal() {
  const [searchParams] = useSearchParams();
  const selectedPeriod = searchParams.get("period");

  const [reportData, setReportData] = useState([]);
  const [totalHours, setTotalHours] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const reportService = new ReportService();

  const periodParts = selectedPeriod ? selectedPeriod.split("-") : [];
  const [month, year] = periodParts.map(Number);

  const isValidPeriod =
    periodParts.length === 2 &&
    !isNaN(month) &&
    !isNaN(year) &&
    month >= 1 &&
    month <= 12;

  useEffect(() => {
    if (!isValidPeriod) return;

    setLoading(true);
    setError("");

    reportService
      .getFechamentoDepPessoal(selectedPeriod)
      .then((data) => {
        setReportData(data.users || []);
        setTotalHours(data.totalHours || 0);
      })
      .catch(() => setError("Erro ao carregar o relatório."))
      .finally(() => setLoading(false));
  }, [selectedPeriod]);

  const periodDate = DateTime.fromObject({ year, month }, { zone: "America/Sao_Paulo" });

  const monthName = periodDate
    .setLocale("pt-BR")
    .toFormat("MMMM")
    .toLowerCase()
    .replace(/^./, (str) => str.toUpperCase());

  const startDate = periodDate.startOf("month").toFormat("dd/MM/yyyy");
  const endDate = periodDate.endOf("month").toFormat("dd/MM/yyyy");

  const yearAndMonth = periodDate.toFormat("yyyy-MM");

  return (
    <div>
      <div className="container mt-4">
        <PrintButton
          fileName={`${yearAndMonth} - RELATÓRIO DE FECHAMENTO - DEP PESSOAL`}
        />

        <div className="row">
          <div className="col-3">
            <img src="/logo.png" alt="Logo" width="120" />
          </div>

          <div className="col-9 text-center">
            <h3 className="fw-bold">GAMA - GUARDA MUNICIPAL DE AMERICANA</h3>
            <h3>SISTEMA DE DIÁRIA ADICIONAL POR ESCALA EXTRAORDINÁRIA</h3>
            <h3>RELATÓRIO DE FECHAMENTO (DEP. PESSOAL)</h3>
          </div>

          <div
            className="col-12 text-end p-2"
            style={{
              display: "inline-block",
              width: "fit-content",
              marginLeft: "auto",
            }}
          >
            <div className="text-center">
              <strong>
                Mês {monthName} {year}
              </strong>
            </div>
            <div>
              <span>
                De: {startDate} a {endDate}
              </span>
            </div>
          </div>
        </div>

        {error && <div className="text-danger mt-3">{error}</div>}
        {loading && <p>Carregando...</p>}

        {reportData.length > 0 && (
          <div className="mt-4">
            <table className="table table-bordered custom-table">
              <thead>
                <tr className="bg-secondary text-white">
                  <th>NOME</th>
                  <th>MAT.</th>
                  <th>DIA</th>
                  <th>NOITE</th>
                </tr>
              </thead>
              <tbody>
                {reportData.map((user, index) => (
                  <tr key={index}>
                    <td>{user.fullName.trim()}</td>
                    <td>{user.username}</td>
                    <td>{(user.dayHours || 0).toFixed(0)}</td>
                    <td>{(user.nightHours || 0).toFixed(0)}</td>
                  </tr>
                ))}
                <tr className="bg-secondary text-white">
                  <td colSpan="3" className="fw-bold text-end school-header">
                    TOTAL
                  </td>
                  <td className="fw-bold school-header">{totalHours.toFixed(0)} HORAS</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
